import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth"; 
import components from "./modules/components"; 
import projects from "./modules/projects"; 
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sidebars: {},
    selectedButton: null,
    isSidebarExpanded: false,
    showFeedback: false,
  },
  getters: {

  },
  mutations: {
    toggleSidebar(state, id) {
      // Si el sidebar con este ID no existe, lo creamos y lo abrimos
      if (!state.sidebars[id]) {
        state.sidebars = { ...state.sidebars, [id]: true };
      } else {
        // Si ya existe, invertimos su estado
        state.sidebars[id] = !state.sidebars[id];
      }
    },
    closeSidebar(state, id) {
      if (state.sidebars[id]) {
        state.sidebars[id] = false;
      }
    },
    selectButton(state, button) {
      state.selectedButton = button;
    },
    SET_SIDEBAR_EXPANDED(state, value) {
      state.isSidebarExpanded = value;
    },
    // Mutación para cambiar el estado de mostrar feedback
    SET_SHOW_FEEDBACK(state, value) {
      state.showFeedback = value;
    },
    // Abrir sidebar custom de la guía de instrucciones
    toggleSidebarInstructions(state) {
      if (state.isSidebarExpanded && state.showFeedback) {
        state.showFeedback = false;
      } else {
      state.isSidebarExpanded = !state.isSidebarExpanded;
        if (state.isSidebarExpanded) {
          state.showFeedback = false;
        }
      }
    },
  },
  actions: {

  },
  modules: {
    auth,
    components,
    projects
  },
});
